import { Box, TextField, Typography } from "@mui/material";
import {
  Control,
  Controller,
  UseFormReturn,
  useFieldArray,
} from "react-hook-form";
import { FC, useEffect } from "react";
import {
  LabelPosition,
  RHookFormTextFieldWithLabel
} from "@websential/cosmic";

import Grid from "@mui/material/Grid";
import { IRemittanceRequestPayload } from "../../../models/common/ITransferRemittance";
import {
  ITest,
} from "@websential/cosmic";

export interface IRemittanceTransferEmployeeSetup extends ITest {
  formMethods: UseFormReturn<any, IRemittanceRequestPayload>;
  items: any;
  dividerOverUnderRemittance: any;
  undoRemitanceTransferRL1: (value: boolean) => void;
}

const FIELD_NAME = "undoremittance11";

interface EnhancedDDLFieldProps extends ITest {
  name: any;
  control: Control<any>;
  label: any;
  formMethods: any;
  defualtValue: any;
  items: any;
}

const CustomFormTextFieldWithLabel: FC<EnhancedDDLFieldProps> = ({
  name,
  control,
  label,
  testId,
  defualtValue,
  formMethods,
  items
}) => {
  const handleInputChange = (e: any) => {
    for (let i = 0; i < items.length; i++) {
      const key = `undoremittance11.${i}.resourceRemittanceValue`;
      if (key === e.target.name) {

        formMethods.setValue(e.target.name, e.target.value);
      }
    }
  };
  return (
    <Controller
      render={({ field, fieldState: { error } }) => {
        const { ref, ...rest } = field;
        return (
          <Grid container size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }} sx={{ margin: "8px 0 4px 0" }}>
            <Grid
              size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography
                sx={{ fontSize: "0.875rem", color: "rgba(0, 0, 0, 0.6)" }}
              >
                {label}
              </Typography>
            </Grid>
            <Grid size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}>
              <TextField
                {...rest}
                id={name}
                {...formMethods.register(name)}
                value={formMethods.watch(name)}
                defaultValue={defualtValue}
                {...(error && { helperText: error.message })}
                onChange={handleInputChange}
                sx={{
                  "& .MuiInputBase-input": { padding: "8.5px 14px", textAlign: "end" },
                  width: "100%",
                  border: 0,
                }}
              />
            </Grid>
          </Grid>
        );
      }}
      name={name}
      control={control}
    />
  );
};
export const UndoRL1RemittanceTransferEmployeeSetup: FC<IRemittanceTransferEmployeeSetup> =
  ({
    formMethods,
    items,
    dividerOverUnderRemittance,
    testId,
    undoRemitanceTransferRL1
  }) => {
    //     const { fields, append, remove } = useFieldArray({
    //       control: formMethods.control,
    //       name: FIELD_NAME,
    //     });

    //     useEffect(() => {
    //       if(items && items !== null){
    //         append(items)
    //         for (let i = 0; i < items && items.length; i++) {
    //     
    //           formMethods.setValue(
    //             `undoremittance11.${i}.resourceRemittanceValue`,
    //             dividerOverUnderRemittance
    //           );
    //         }
    //       }
    //     }, []);

    undoRemitanceTransferRL1(true)
    return (
      <>
        {/* {fields && fields.map((item:any, index) => {
          return (
            <Grid container xs={12} key={item.slipId} alignItems="center">

                <CustomFormTextFieldWithLabel
                  name={`${FIELD_NAME}.${index}.resourceRemittanceValue`}
                  label={item && item.resourceFirstName}
                  control={formMethods.control}
                  testId={`${testId}-${index}-code`}
                  formMethods={formMethods}
                  defualtValue={dividerOverUnderRemittance && dividerOverUnderRemittance}
                  items={items}
                />
              </Grid>
          );
        })} */}

        {items && items.map((item: any, index: any) => {
          return (
            <Box sx={{ paddingBottom: 2, display: "flex", justifyContent: "space-between" }}>
              <Typography>{item.resourceFirstName}</Typography>
              <Typography>{item.resourceRemittanceValue}</Typography>
            </Box>
          )
        })}

      </>
    );
  };
